import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { DiseaseFilterSettingsModel } from "../../../models/diseaseFilterSettingsModel";
import AlphabeticalFilter from '../../../common/components/alphabeticalFilter/alphabeticalFilter';
import Translate from '../../../common/functions/translate';

interface IProps {
    onSearchClick: any,
    totalRecordsCount: number,
    lang: string
    onClearClick: any;
}

interface IState {
    diseaseSettings: DiseaseFilterSettingsModel,
    selectedType: null,
    selectedGroup: null,
    filterText: string
}

export class DiseaseFilter extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props);
        this.state = {
            diseaseSettings: new DiseaseFilterSettingsModel(),
            selectedType: null,
            selectedGroup: null,
            filterText: ''
        };
    }

    handleAlphaIndexChange = (e, letter: string) => {
        e.preventDefault();
        const currentSettings: DiseaseFilterSettingsModel = { ...this.state.diseaseSettings };
        currentSettings.diseaseName = '';
        currentSettings.alphaIndex = letter;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            diseaseSettings: { ...currentSettings },
            filterText: fiterText
        });
        this.handleSearchButtonClick(currentSettings);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name;

        const currentSettings: DiseaseFilterSettingsModel = { ...this.state.diseaseSettings };
        currentSettings[name] = value;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            diseaseSettings: { ...currentSettings },
            filterText: fiterText
        }, this.searchByName);
    }

    searchByName = () => {
        if (this.state.diseaseSettings && this.state.diseaseSettings.diseaseName && this.state.diseaseSettings.diseaseName.length >= 3) {
            this.handleSearchButtonClick(this.state.diseaseSettings)
        }
    }

    generateFilterText = (settings: DiseaseFilterSettingsModel) => {
        let result = '';

        if (settings.alphaIndex) {
            result += Translate("Start with") + " <strong>'" + settings.alphaIndex + "'</strong>, "
        }
        if (settings.diseaseName) {
            result += Translate("Name") + " <strong>'" + settings.diseaseName + "'</strong>, "
        }

        return result.substr(0, result.length - 2);
    }

    handleSearchButtonClick = (settings) => {
        this.props.onSearchClick(settings);
    }

    handleClearButtonClick = () => {
        this.setState({
            diseaseSettings: new DiseaseFilterSettingsModel(),
            filterText: ''
        });
        this.props.onClearClick();
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchButtonClick(this.state.diseaseSettings)
        }
    }

    render() {
        return (
            <div style={{ marginBottom: '10px', content: "", display: 'table', clear: 'both' }}>
                <div className="p-col-12">
                    <div className="p-inputgroup">
                        <InputText
                            onKeyDown={(e) => this.handleKeyPress(e)}
                            style={{ width: '100%' }}
                            name="diseaseName"
                            placeholder={Translate('EnterDiseaseName')}
                            onChange={this.handleChange}
                            value={this.state.diseaseSettings && this.state.diseaseSettings.diseaseName ? this.state.diseaseSettings.diseaseName : ''}
                        />
                        <Button icon="pi pi-times" className="p-button-warning" onClick={() => this.handleClearButtonClick()} />
                        <Button icon="pi pi-search" onClick={() => this.handleSearchButtonClick(this.state.diseaseSettings)} />
                    </div>
                </div>
                <div className="p-col-12" >
                    <span style={{ fontSize: '12px', color: '#777' }}>{Translate('BrowseAlphabetically')}:</span>
                    <AlphabeticalFilter
                        handleAlphaIndexChange={this.handleAlphaIndexChange}
                        filters={["bg", "en"]}
                        buttonStyle={true}
                        letterClassName="p-button-secondary p-button-raised"
                    />
                </div>
                <div className="p-col-12">
                    <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
                        {Translate('Result')}: <strong>{this.props.totalRecordsCount}</strong>
                        {this.state.filterText ? ', ' : ''}
                        <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
                    </div>
                </div>
            </div >
        )
    }
}

export default DiseaseFilter;
